import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stripSpaces' })
export class StripSpacesPipe implements PipeTransform {
  transform(text: string): string {
    text = text || '';
    return text.replace(' ', '');
  }
}

// tslint:disable-next-line:max-classes-per-file
@Pipe( { name: 'addSpaceBeforeCapitals'})
export class AddSpaceBeforeCapitals implements PipeTransform {
  transform(text: string): string{
    let result = '';    
    let  i = 0 ;
    for (i = 0; i < text.length; i++ )
    {
      const c = text.charAt(i);
      if (c === c.toUpperCase())
      {
        result = result + ' ';
      }
      result = result + c;
    }    
    return result;
  }
}
